import React from "react";
import { FaExclamationCircle } from "react-icons/fa";

function OverdueBanner({ count, onRescheduleAll, onDismiss }) {
  if (count === 0) return null;
  return (
    <div className="dal-overdue-banner mb-3 flex items-center justify-between gap-3 rounded-xl border border-rose-200 bg-rose-50 px-4 py-2.5">
      <div className="flex items-center gap-2 text-xs font-medium text-rose-700">
        <FaExclamationCircle size={13} />
        {count} task{count > 1 ? "s are" : " is"} overdue
      </div>
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onRescheduleAll}
          className="rounded-lg bg-rose-600 px-3 py-1.5 text-[11px] font-semibold text-white transition hover:bg-rose-700"
        >
          Move all to today
        </button>
        <button type="button" onClick={onDismiss} className="text-[11px] font-medium text-rose-400 hover:text-rose-600">
          Dismiss
        </button>
      </div>
    </div>
  );
}

export default OverdueBanner;